"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RowsChangeEventType;
(function (RowsChangeEventType) {
    RowsChangeEventType[RowsChangeEventType["ROW_ACTIVATED"] = 0] = "ROW_ACTIVATED";
    RowsChangeEventType[RowsChangeEventType["ROW_DEACTIVATED"] = 1] = "ROW_DEACTIVATED";
    RowsChangeEventType[RowsChangeEventType["ROW_CREATED"] = 2] = "ROW_CREATED";
    RowsChangeEventType[RowsChangeEventType["ROW_HIGHLIGHTED"] = 3] = "ROW_HIGHLIGHTED";
    RowsChangeEventType[RowsChangeEventType["ROW_UNHIGHLIGHTED"] = 4] = "ROW_UNHIGHLIGHTED";
    RowsChangeEventType[RowsChangeEventType["ROW_COLLAPSED"] = 5] = "ROW_COLLAPSED";
    RowsChangeEventType[RowsChangeEventType["ROW_EXPANDED"] = 6] = "ROW_EXPANDED";
    RowsChangeEventType[RowsChangeEventType["ROW_REMOVED"] = 7] = "ROW_REMOVED";
})(RowsChangeEventType = exports.RowsChangeEventType || (exports.RowsChangeEventType = {}));
//# sourceMappingURL=rows-change-event-type.js.map